import React, { useState } from 'react';
import { InstagramIcon, FacebookIcon, MessageCircleIcon, XIcon } from 'lucide-react';
export function Footer() {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  return <footer className="bg-petrol-lighter pt-20 pb-10 border-t border-petrol-light" data-id="element-48">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-49">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-50">
          <div className="col-span-1 md:col-span-2" data-id="element-51">
            <a href="#home" className="flex items-center gap-2 mb-6 group inline-flex" data-id="element-52">
              <img src="https://cdn.magicpatterns.com/uploads/qNXWZ3SnSyEmwvnJR5unkd/1000116463.png" alt="Anchor Innovative Solutions" className="h-12 w-auto mix-blend-screen transition-transform group-hover:scale-105" data-id="element-53" />
              <span className="font-serif text-2xl font-bold tracking-wider text-white" data-id="element-54">
                ANCHOR
              </span>
            </a>
            <p className="text-silver max-w-sm leading-relaxed mb-8" data-id="element-55">
              Agencia de crecimiento digital remota. Ayudamos a profesionales en
              el área de la salud a anclar su presencia digital.
            </p>
            <div className="flex items-center gap-4" data-id="element-56">
              <a href="https://instagram.com/anchorinnovativesolutions" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-petrol flex items-center justify-center text-silver hover:text-turquoise hover:bg-petrol-light transition-all border border-transparent hover:border-turquoise/30" aria-label="Instagram" data-id="element-57">
                <InstagramIcon className="w-5 h-5" data-id="element-58" />
              </a>
              <a href="https://www.facebook.com/profile.php?id=61586292661912" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-petrol flex items-center justify-center text-silver hover:text-turquoise hover:bg-petrol-light transition-all border border-transparent hover:border-turquoise/30" aria-label="Facebook" data-id="element-59">
                <FacebookIcon className="w-5 h-5" data-id="element-60" />
              </a>
            </div>
          </div>

          <div data-id="element-61">
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-62">
              Navegación
            </h4>
            <ul className="space-y-4" data-id="element-63">
              <li data-id="element-64">
                <a href="#home" className="text-silver hover:text-turquoise transition-colors" data-id="element-65">
                  Inicio
                </a>
              </li>
              <li data-id="element-66">
                <a href="#nicho" className="text-silver hover:text-turquoise transition-colors" data-id="element-67">
                  Soluciones
                </a>
              </li>
              <li data-id="element-68">
                <a href="#servicios" className="text-silver hover:text-turquoise transition-colors" data-id="element-69">
                  Servicios
                </a>
              </li>
              <li data-id="element-70">
                <a href="#metodologia" className="text-silver hover:text-turquoise transition-colors" data-id="element-71">
                  Metodología
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-72">
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-73">
              Contacto
            </h4>
            <ul className="space-y-4" data-id="element-74">
              <li data-id="element-75">
                <a href="https://wa.me/50672642898" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-silver hover:text-turquoise transition-colors" data-id="element-76">
                  <MessageCircleIcon className="w-4 h-4" data-id="element-77" />
                  +506 72642898
                </a>
              </li>
              <li data-id="element-78">
                <span className="text-silver" data-id="element-79">Remoto Latinoamérica</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-petrol-light flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-80">
          <p className="text-silver-light text-sm opacity-60" data-id="element-81">
            &copy; {new Date().getFullYear()} Anchor Innovative Solutions. Todos
            los derechos reservados.
          </p>
          <div className="flex items-center gap-6 text-sm text-silver-light opacity-60" data-id="element-82">
            <button onClick={() => setShowPrivacy(true)} className="hover:text-turquoise transition-colors cursor-pointer" data-id="element-83">
              Privacidad
            </button>
            <button onClick={() => setShowTerms(true)} className="hover:text-turquoise transition-colors cursor-pointer" data-id="element-84">
              Términos
            </button>
          </div>
        </div>
      </div>

      {/* Terms Modal */}
      {showTerms && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={() => setShowTerms(false)} data-id="element-85">
          <div className="bg-petrol-light border border-petrol-lighter rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-86">
            <div className="sticky top-0 bg-petrol-light border-b border-petrol-lighter p-6 flex items-center justify-between rounded-t-2xl" data-id="element-87">
              <h3 className="text-xl font-bold text-white" data-id="element-88">
                Términos y Condiciones
              </h3>
              <button onClick={() => setShowTerms(false)} className="text-silver hover:text-white transition-colors" data-id="element-89">
                <XIcon className="w-5 h-5" data-id="element-90" />
              </button>
            </div>
            <div className="p-6 space-y-6 text-silver text-sm leading-relaxed" data-id="element-91">
              <div data-id="element-92">
                <h4 className="text-white font-semibold mb-2" data-id="element-93">
                  1. Aceptación de los Términos
                </h4>
                <p data-id="element-94">
                  Al acceder y utilizar los servicios de Anchor Innovative
                  Solutions, usted acepta estar sujeto a estos términos y
                  condiciones. Si no está de acuerdo con alguna parte de estos
                  términos, no podrá acceder al servicio.
                </p>
              </div>
              <div data-id="element-95">
                <h4 className="text-white font-semibold mb-2" data-id="element-96">2. Servicios</h4>
                <p data-id="element-97">
                  Anchor Innovative Solutions ofrece servicios de diseño web,
                  desarrollo de landing pages y gestión de pauta publicitaria
                  digital (Media Buying). Los entregables, plazos y alcance
                  específico se definirán en cada propuesta comercial
                  individual.
                </p>
              </div>
              <div data-id="element-98">
                <h4 className="text-white font-semibold mb-2" data-id="element-99">
                  3. Propiedad Intelectual
                </h4>
                <p data-id="element-100">
                  Todo el contenido, diseños, código y materiales creados por
                  Anchor Innovative Solutions permanecerán como propiedad de la
                  agencia hasta que se realice el pago completo del proyecto.
                  Una vez liquidado, los derechos de uso se transfieren al
                  cliente.
                </p>
              </div>
              <div data-id="element-101">
                <h4 className="text-white font-semibold mb-2" data-id="element-102">
                  4. Pagos y Facturación
                </h4>
                <p data-id="element-103">
                  Los pagos se realizarán según los términos acordados en la
                  propuesta comercial. Se requiere un anticipo del 50% para
                  iniciar cualquier proyecto. El saldo restante se pagará al
                  momento de la entrega final.
                </p>
              </div>
              <div data-id="element-104">
                <h4 className="text-white font-semibold mb-2" data-id="element-105">
                  5. Confidencialidad
                </h4>
                <p data-id="element-106">
                  Ambas partes se comprometen a mantener la confidencialidad de
                  toda la información compartida durante la relación comercial,
                  incluyendo estrategias, datos de acceso y métricas de
                  rendimiento.
                </p>
              </div>
              <div data-id="element-107">
                <h4 className="text-white font-semibold mb-2" data-id="element-108">
                  6. Limitación de Responsabilidad
                </h4>
                <p data-id="element-109">
                  Anchor Innovative Solutions no será responsable por resultados
                  específicos de ventas o conversiones, ya que estos dependen de
                  múltiples factores externos. Nos comprometemos a aplicar las
                  mejores prácticas de la industria en cada proyecto.
                </p>
              </div>
              <div data-id="element-110">
                <h4 className="text-white font-semibold mb-2" data-id="element-111">
                  7. Cancelación
                </h4>
                <p data-id="element-112">
                  El cliente puede cancelar el servicio con un aviso previo de
                  15 días. Los trabajos realizados hasta la fecha de cancelación
                  serán facturados proporcionalmente. El anticipo no es
                  reembolsable una vez iniciado el proyecto.
                </p>
              </div>
              <div data-id="element-113">
                <h4 className="text-white font-semibold mb-2" data-id="element-114">8. Contacto</h4>
                <p data-id="element-115">
                  Para cualquier consulta sobre estos términos, puede
                  contactarnos a través de WhatsApp al +506 72642898 o mediante
                  nuestras redes sociales oficiales.
                </p>
              </div>
            </div>
          </div>
        </div>}

      {/* Privacy Modal */}
      {showPrivacy && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={() => setShowPrivacy(false)} data-id="element-116">
          <div className="bg-petrol-light border border-petrol-lighter rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-117">
            <div className="sticky top-0 bg-petrol-light border-b border-petrol-lighter p-6 flex items-center justify-between rounded-t-2xl" data-id="element-118">
              <h3 className="text-xl font-bold text-white" data-id="element-119">
                Política de Privacidad
              </h3>
              <button onClick={() => setShowPrivacy(false)} className="text-silver hover:text-white transition-colors" data-id="element-120">
                <XIcon className="w-5 h-5" data-id="element-121" />
              </button>
            </div>
            <div className="p-6 space-y-6 text-silver text-sm leading-relaxed" data-id="element-122">
              <div data-id="element-123">
                <h4 className="text-white font-semibold mb-2" data-id="element-124">
                  1. Información que Recopilamos
                </h4>
                <p data-id="element-125">
                  Anchor Innovative Solutions recopila información personal que
                  usted nos proporciona voluntariamente al contactarnos, como su
                  nombre, número de teléfono, correo electrónico y detalles
                  sobre su negocio o proyecto.
                </p>
              </div>
              <div data-id="element-126">
                <h4 className="text-white font-semibold mb-2" data-id="element-127">
                  2. Uso de la Información
                </h4>
                <p data-id="element-128">
                  Utilizamos su información exclusivamente para: responder a sus
                  consultas, elaborar propuestas comerciales personalizadas,
                  ejecutar los servicios contratados y enviar comunicaciones
                  relevantes sobre nuestros servicios.
                </p>
              </div>
              <div data-id="element-129">
                <h4 className="text-white font-semibold mb-2" data-id="element-130">
                  3. Protección de Datos
                </h4>
                <p data-id="element-131">
                  Implementamos medidas de seguridad técnicas y organizativas
                  para proteger su información personal contra acceso no
                  autorizado, alteración, divulgación o destrucción. Sus datos
                  se almacenan en servidores seguros con acceso restringido.
                </p>
              </div>
              <div data-id="element-132">
                <h4 className="text-white font-semibold mb-2" data-id="element-133">
                  4. Compartir Información
                </h4>
                <p data-id="element-134">
                  No vendemos, comercializamos ni transferimos su información
                  personal a terceros sin su consentimiento, excepto cuando sea
                  necesario para la prestación de los servicios contratados (por
                  ejemplo, plataformas publicitarias como Meta o Google Ads).
                </p>
              </div>
              <div data-id="element-135">
                <h4 className="text-white font-semibold mb-2" data-id="element-136">
                  5. Cookies y Tecnologías de Seguimiento
                </h4>
                <p data-id="element-137">
                  Nuestro sitio web puede utilizar cookies y tecnologías
                  similares para mejorar la experiencia del usuario y analizar
                  el tráfico. Usted puede configurar su navegador para rechazar
                  cookies, aunque esto podría afectar la funcionalidad del
                  sitio.
                </p>
              </div>
              <div data-id="element-138">
                <h4 className="text-white font-semibold mb-2" data-id="element-139">
                  6. Derechos del Usuario
                </h4>
                <p data-id="element-140">
                  Usted tiene derecho a acceder, rectificar, eliminar o limitar
                  el tratamiento de sus datos personales en cualquier momento.
                  Para ejercer estos derechos, contáctenos a través de WhatsApp
                  al +506 72642898.
                </p>
              </div>
              <div data-id="element-141">
                <h4 className="text-white font-semibold mb-2" data-id="element-142">
                  7. Cambios en la Política
                </h4>
                <p data-id="element-143">
                  Nos reservamos el derecho de actualizar esta política de
                  privacidad en cualquier momento. Los cambios serán publicados
                  en esta página y entrarán en vigor inmediatamente después de
                  su publicación.
                </p>
              </div>
              <div data-id="element-144">
                <h4 className="text-white font-semibold mb-2" data-id="element-145">8. Contacto</h4>
                <p data-id="element-146">
                  Si tiene preguntas sobre nuestra política de privacidad, puede
                  contactarnos a través de WhatsApp al +506 72642898 o mediante
                  nuestras redes sociales oficiales
                  (@anchorinnovativesolutions).
                </p>
              </div>
            </div>
          </div>
        </div>}
    </footer>;
}